import { render } from "./CustomSelectOneBookType.vue?vue&type=template&id=04829d76"
import script from "./CustomSelectOneBookType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneBookType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__